<template>
    <droppable
        v-if="isVisible"
        element-type="droppable"
        :component-name="componentName"
        :filled="!!elementsNew.length"
        :force-display="forceDisplay"
        :index="elementsNew.length"
        :is-structural-component="isStructuralComponent"
        :scroll-on-drop="scrollOnDrop"
        :text="text"
        :top-level="topLevel"
        @drop="onDrop"
        @click.native.right="event => openPasteMenu(event, elementsNew.length)"
        @paste="pasteElement"
    />
</template>

<script>
import dropZoneMixin from '@/mixins/drop-zone';

const publicMode = process.env.VUE_APP_ENV === 'public';

export default {
    name: 'drop-zone-input',
    mixins: [dropZoneMixin],

    props: {
        componentName: {
            type: String,
            default: '',
        },

        elementsNew: {
            type: Array,
            required: true,
        },

        forceDisplay: {
            type: Boolean,
            default: false,
        },

        isStructuralComponent: {
            type: Boolean,
            default: false,
        },

        limit: {
            type: Number,
            default: 0,
        },

        text: {
            type: String,
            default: '',
        },

        topLevel: {
            type: Boolean,
            default: false,
        },

        scrollOnDrop: {
            type: Boolean,
            default: false,
        },

    },

    computed: {
        isVisible() {
            return !publicMode && !this.limitReached;
        },

        limitReached() {
            if (!this.limit) return false;

            return this.elementsNew.length >= this.limit;
        },
    },
};
</script>
